module.exports = __webpack_public_path__ + "images/bannerIT-706eb4ed490d6d7cbcc275adea000f9b.png";